export enum PopupIconNames {
	Information = 'information-icon',
	Question = 'question-icon',
	Warning = 'warning-icon'
}